module.exports = __webpack_public_path__ + "78d1603f161074aefe5e5a5bf4291024.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Talbot.png
// module id = yfky
// module chunks = 0